
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

export enum CheckboxPredefinedStyle {
  Grey = 'checkbox--grey-style',
  Secondary = 'checkbox--secondary-style',
}

@Component({
  components: {
    Icon,
  },
})
export default class Checkbox extends Vue {
  @Prop({ default: false }) private active!: boolean;
  @Prop({ default: false }) private disabled!: boolean;
  @Prop({ default: '' }) private checkboxLabel!: string;
  @Prop({ default: false }) private squared!: boolean;
  @Prop({ default: '' }) private checkboxText!: string;
  @Prop({ default: '' }) private checkboxError!: string;
  @Prop({ default: CheckboxPredefinedStyle.Secondary })
  private checkboxPredefinedStyle!: CheckboxPredefinedStyle;

  private iconEnum = IconEnum;

  get hasLabel() {
    return this.checkboxLabel.length > 0;
  }

  get hasError() {
    return this.checkboxError !== '';
  }

  private hideError() {
    this.$emit('hide-error');
  }

  private handleClick() {
    if (!this.disabled) {
      this.hideError();
      this.$emit('input', !this.active);
      this.$emit('checkbox-click');
    }
  }
}
